// Components==============
import { useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
// =========================

type RequestType = Partial<AnswerEntity>;

const storeAnswer = (data: RequestType) =>
  axios.post("/api/answer", data).then((r) => r.data);

export default function useStoreAnswer() {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: storeAnswer,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["answer"] });
    },
    onError: (error) => {
      console.error("Error storing answer", error);
    },
  });

  return mutation;
}
